import { useCreateLeagueMatchStore } from "../../../store/StoreContext";
import { DatesList } from "./DateList";
import { SectionBackground } from "./SectionBackground";
import { observer } from "mobx-react-lite";
import { SelectCourtType } from "./SelectCourtType";
import { SelectTimeSlot } from "./SelectTimeSlot";
import { MinimumPlayingTime } from "./MinimumPlayingTime";

export const SelectDateAndTime = observer(() => {
  const createLeagueMatchStore = useCreateLeagueMatchStore();

  return (
    <SectionBackground title={"Select the day and time you can play"}>
      <DatesList />
      <SelectCourtType />
      {createLeagueMatchStore.timeSlotsResponse ? (
        <>
          <SelectTimeSlot />
          <MinimumPlayingTime />
        </>
      ) : null}
    </SectionBackground>
  );
});
